/*
 * ta-sticky-cart — floating CTA bar for the TA product hero.
 *
 * Shows a fixed bar at the bottom of the screen once the hero's CTA block
 * (the element referenced by data-form-id) has scrolled out of view above
 * the viewport, and hides it again when it is back in view or the footer is
 * reached. On the weight-loss PDPs that block is a plain <div> whose CTA
 * links to the funnel; the variant <select> sync below only runs when a
 * legacy cart form with a variant picker is present.
 */
(function () {
  'use strict';

  if (window.__taStickyCart) return;
  window.__taStickyCart = true;

  function initBar(bar) {
    if (bar.__taInit) return;
    bar.__taInit = true;

    var formId = bar.getAttribute('data-form-id');
    var form = formId ? document.getElementById(formId) : null;
    if (!form) return;

    // The hero section uses `isolation: isolate`, creating a stacking context
    // that traps this fixed bar so later sections paint over it. Relocate the
    // bar to <body> so it lives in the root stacking context.
    if (bar.parentElement !== document.body) {
      var selector = '[data-ta-sticky-cart][data-form-id="' + formId.replace(/"/g, '\\"') + '"]';
      var existing = document.querySelectorAll('body > ' + selector);
      for (var d = 0; d < existing.length; d++) {
        if (existing[d] !== bar) existing[d].remove();
      }
      document.body.appendChild(bar);
    }

    var visible = false;

    function show() {
      if (visible) return;
      visible = true;
      bar.classList.add('is-visible');
      bar.setAttribute('aria-hidden', 'false');
    }

    function hide() {
      if (!visible) return;
      visible = false;
      bar.classList.remove('is-visible');
      bar.setAttribute('aria-hidden', 'true');
    }

    function formScrolledPast() {
      return form.getBoundingClientRect().bottom < 0;
    }

    // Toggle on the hero form's visibility.
    var formObserver = new IntersectionObserver(function (entries) {
      var entry = entries[0];
      if (!entry) return;
      if (entry.isIntersecting) {
        hide();
      } else if (formScrolledPast()) {
        show();
      } else {
        hide();
      }
    }, { threshold: 0 });
    formObserver.observe(form);

    // Keep the bar clear of the footer.
    var footer = document.querySelector('.ta-footer') || document.querySelector('footer');
    if (footer) {
      var footerObserver = new IntersectionObserver(function (entries) {
        var entry = entries[0];
        if (!entry) return;
        if (entry.isIntersecting) {
          hide();
        } else if (formScrolledPast()) {
          show();
        }
      }, { threshold: 0 });
      footerObserver.observe(footer);
    }

    // Keep the bar's price in sync with the variant <select>.
    var select = form.querySelector('select[name="id"]');
    var priceEl = bar.querySelector('[data-ta-sticky-price]');
    if (select && priceEl) {
      var suffix = priceEl.querySelector('.ta-pdp-hero__price-suffix');
      var suffixHtml = suffix ? suffix.outerHTML : '';
      select.addEventListener('change', function () {
        var opt = select.options[select.selectedIndex];
        var price = opt && opt.getAttribute('data-price');
        if (price) priceEl.innerHTML = price + suffixHtml;
      });
    }
  }

  function init(scope) {
    var bars = (scope || document).querySelectorAll('[data-ta-sticky-cart]');
    for (var i = 0; i < bars.length; i++) initBar(bars[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
